import { HttpParams } from '@angular/common/http';
import { BaseFilterViewModel } from './base-filter-view-model';

export class ReviewFilterViewModel extends BaseFilterViewModel {
  public Type: ReviewFilterType = ReviewFilterType.Keywords;
  public CorrespondenceId: number;

  public getAsHttpParams(): HttpParams {
    let params = super.getAsHttpParams();
    params = params.append('filter.Type', encodeURIComponent(`${this.Type}`));
    params = params.append(
      'filter.CorrespondenceId',
      '' + this.CorrespondenceId
    );
    return params;
  }
}

export enum ReviewFilterType {
  /** Search using the Keywords property across all fields (email, hawkId, etc). */
  Keywords = 0x1,

  ByCorrespondenceId = 0x2,
}
